<template>

  <div class="full-height">
    <el-container class="full-height">
      <el-aside width="200px">
        <MenuBar />
      </el-aside>


      <el-container>
        <el-header>
          <TopStatistics :projects-count="store.projects.length" @logout="emit('logout', true)"/>
        </el-header>
        <el-main>

          <router-view id="router" />
        </el-main>
      </el-container>
    </el-container>
  </div>

</template>

<script setup lang="ts">

import TopStatistics from './TopStatistics.vue';
import MenuBar from './MenuBar.vue';
import store from '@/stores/store';



const emit = defineEmits([
  'logout'
])

</script>

<style scoped>
.el-aside {
  border-right: solid 2px var(--main-text-color);
}
.el-header {
  --el-header-padding: none;
}

.el-main {
  padding-bottom: 10px;
}
</style>
